/**
 * Case search domain types
 *
 * Re-exports GraphQL types from generated schema to maintain single source of truth.
 * See: docs/strategy/graphql-type-reuse-guide.md
 */

// Re-export GraphQL types from generated schema
export type { CaseSearchInput, CaseSearchResponse, CaseSearchResultItem } from '@core/graphql/types/schema';

/**
 * Available search types
 */
export enum SearchType {
  SUBJECT_ID = 'Subject ID',
  USER_ID = 'User ID',
  CASE_ID = 'Case ID',
}

/**
 * Available user types for case search
 */
export enum UserType {
  XBOX = 'Xbox',
  // Add more user types as needed
}

/**
 * Search filters for case search
 * Extends CaseSearchInput with domain-specific enums
 */
export interface CaseSearchFilters {
  searchType: SearchType;
  userType?: UserType;
  searchValue: string;
  communityId?: string;
}
